import _get from "lodash/get";
import layoutTheme from '../../styles/layoutTheme';

var xsView = function xsView(_ref, _ref2) {
  var width = _ref.width;
  var theme = _ref2.theme;
  var breakpoint = _get(theme, 'layout.media.xs', layoutTheme.layout.media.xs) - 1;
  return width <= breakpoint;
};

var smView = function smView(_ref3, _ref4) {
  var width = _ref3.width;
  var theme = _ref4.theme;
  var breakpoint = _get(theme, 'layout.media.sm', layoutTheme.layout.media.sm) - 1;
  return width <= breakpoint;
};

var mdView = function mdView(_ref5, _ref6) {
  var width = _ref5.width;
  var theme = _ref6.theme;
  var breakpoint = _get(theme, 'layout.media.md', layoutTheme.layout.media.md) - 1;
  return width <= breakpoint;
};

var lgView = function lgView(_ref7, _ref8) {
  var width = _ref7.width;
  var theme = _ref8.theme;
  var breakpoint = _get(theme, 'layout.media.lg', layoutTheme.layout.media.lg) - 1;
  return width <= breakpoint;
};

var xlView = function xlView(_ref9, _ref10) {
  var width = _ref9.width;
  var theme = _ref10.theme;
  var breakpoint = _get(theme, 'layout.media.xl', layoutTheme.layout.media.xl) - 1;
  return width <= breakpoint;
};

export default {
  xsView: xsView,
  smView: smView,
  mdView: mdView,
  lgView: lgView,
  xlView: xlView
};